import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id E211A028-22EA-4A78-9306-FC8FF8494D02
 * name abugida-devanagari
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/abugida-devanagari.svg
 * tags
 * - Alpha / Numeric 
 */
export const AbugidaDevanagariIcon = createSvgIcon(<><path d="M8 3V5H11C12.32 5 13.41 5.83 13.82 7H6V9H14V10H12C9.25 10 7 12.25 7 15C7 17.75 9.25 20 12 20C12.77 20 13.45 19.73 14 19.3V21H16V17H14C13.55 17.62 12.83 18 12 18C10.33 18 9 16.67 9 15C9 13.33 10.33 12 12 12H16V9H18V7H15.9C15.43 4.72 13.41 3 11 3H8Z" /></>, 'AbugidaDevanagariIcon');
export default AbugidaDevanagariIcon